/*  ==========================================================================
    ROOMS DETAIL
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import { initDynform } from '../../ehotelier/dynforms/init'

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierRoomMinPrice(data);

    // get desired room
    let roomDetail,
        roomId = location.pathname.match(/(\d+)\/?$/i)[1];
    $.each(data.records, function(key, record) {
        $.each(record.roomtypes, function(key, roomtype) {
            if(roomtype.id == roomId) {
                roomDetail = roomtype;
            }
        });
    });
    data.roomdetail = roomDetail;

    // replace title-tag in the head area with room title (and add it also to the breadcrumb)
    let roomTitle;
    $.each(data.records, function(key, record) {
        $.each(record.roomtypes, function(key, roomtype) {
            if(roomtype.id == roomId) {
                roomTitle = roomtype.name;
            }
        });
    });
    $('title').html(roomTitle);
    $('#bn-breadcrumb').find('.bn-breadcrumb__cur').html(roomTitle);

}

// custom function
function funcCustom(container,data) {

    // magnific popup
    utils.mfp.initGallery(container);
    utils.mfp.initIframe(container);
    utils.mfp.initSingleImage(container);

    // initialize image slider
    let $sliderContainer = $(container).find('.bn-room-box__slider'),
        sliderOverrides = {
            nextArrow: vars.slick_nextArrow,
            prevArrow: vars.slick_prevArrow
        };
    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    // create price list (if container is in view)
    let priceServiceContainer = $(container).find('.eh-rates');
    $(priceServiceContainer).one('inview', function() {
        utils.ehotelierPrices.initEhotelierRoomPriceList(priceServiceContainer);
    });
    
    const getCode = (code, elem) => {
        if ((code in elem.dataset && elem.dataset !== '')) {
            if (data.type === 'offer') {
                return elem.dataset[code]
            } else if (data.type === 'room') {
                return utils.general.splitToArray(elem.dataset[code])
            }
        }
        return []
    }
    
    const formElement = container[0].querySelectorAll('.bn_dynForm.bn_request')
    const initForm = (e) => {
        e.forEach((elem) => {
            initDynform({ formContainerId: elem.id, roomcodes: getCode('room_code', elem)})
        })
    }
    initForm(formElement)
}

// initialization
export function initRoomDetail($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'room',
        subtype: 'detail'
    };

    // ehotelier service initialization
    utils.ehotelierLoader.initEhotlierService(config);

}



// WEBPACK FOOTER //
// ./source/js/modules/lib/room-detail.js